var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "gray-area", attrs: { id: "content" } }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "row" },
        [_c("sdr-breadcrumbs", { attrs: { module: "booking" } })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "container shortcode travel-ideas" }, [
          _c(
            "h1",
            {
              staticClass: "idea-title",
              staticStyle: { "margin-bottom": "20px", color: "red" },
            },
            [
              _vm._m(0),
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.pleaseselectoverview[_vm.getCurrentLocale]) +
                  "\n                "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-8 col-md-9", attrs: { id: "main" } }, [
          _c(
            "div",
            {
              staticClass: "booking-information sdr-box",
              staticStyle: { border: "1px solid red" },
            },
            [
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "booking-confirmation clearfix" }, [
                _c("i", { staticClass: "soap-icon-notice icon circle" }),
                _vm._v(" "),
                _c("div", { staticClass: "message" }, [
                  _c("h4", { staticClass: "main-message" }, [
                    _vm._v(_vm._s(_vm.explanation[_vm.getCurrentLocale])),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(_vm.explanationsub[_vm.getCurrentLocale])),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "print-button button btn-small sundair",
                    attrs: { href: "https://fensterplatz.tickets" },
                  },
                  [_vm._v(_vm._s(_vm.goback[_vm.getCurrentLocale]))]
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("h2", [_vm._v(_vm._s(_vm.solution[_vm.getCurrentLocale]))]),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(_vm.solutiontext[_vm.getCurrentLocale]),
                },
              }),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                  },
                },
                [
                  _c("div", [
                    _c("p", { staticClass: "red-color" }, [
                      _vm._v(_vm._s(_vm.paymentmethod[_vm.getCurrentLocale])),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "red-color underline view-link",
                        attrs: { href: "#" },
                      },
                      [_vm._v("https://mein-wunschplatz.de/")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sidebar col-sm-4 col-md-3" },
          [_c("sdr-contact-box")],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-error circle" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "flex", "justify-content": "end" } },
      [
        _c("img", {
          attrs: { src: "/res/images/icon/warning.png", width: "25%" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }